// extracted by mini-css-extract-plugin
export var popup = "Popup-module--popup--2NKNM";
export var popup__container = "Popup-module--popup__container--2XrcC";
export var popup__content = "Popup-module--popup__content--1bzlP";
export var popup__overflow = "Popup-module--popup__overflow--UzbGP";
export var popup__close = "Popup-module--popup__close--3kvjP";
export var popup_full = "Popup-module--popup_full--19cYm";